import { AbacoVuexModule, State } from '@abaco/web-common/src/app';
import { BlockDataFilter, Crop } from "./models";
import { FilterPlot, Plot } from "@abaco/portal-global-state/src/modules/global-state/models/Plot";

export default class MelaviVuexModule extends AbacoVuexModule {
    @State() curCulture!: Crop | null;
    @State({ default: [] }) filteredPlots!: Plot[];
    @State({ default: { rotation: 1 } }) crossFilters!: FilterPlot;
    @State() scsMapClickPoint!: number[]
    @State({
        default: {
            company_name: "",
            global_gap: "",
            lot_group_description: "",
            council_label: "",
            plot_name: "",
            plot_crop: "",
            plot_area: "",
            block_code: "",
            block_area: "",
            block_num_plants: "",
            sub_block_code: "",
            sub_block_area: "",
            sub_block_num_plants: "",
            sub_block_planting_year: "",
            sub_block_interrow_distance: "",
            sub_block_planting_distance: "",
        }
    }) filter!: BlockDataFilter;
}
